// Runtime environment resolver. The frontend bundle is environment-agnostic —
// one build serves all environments (dev/qa1/uat/prod). The env is sourced
// server-side (backend injects window.__ENV__ into index.html) instead of
// baked at build time via process.env.REACT_APP_*. This is required so a
// single ECS image can be deployed to both uat and prod (the shared
// ams-ecs-application module builds one image and deploys it twice).
//
// Server-side injection avoids the failure mode where a Route53 rename or
// non-matching hostname silently falls back to production assets on a
// lower env. The backend always knows the correct env authoritatively
// (NODE_ENV set by EB, or ENV_VAR mapped to NODE_ENV by default-init.sh
// on ECS), and the frontend inherits it directly.

export const ENV_LOCAL = 'local'
export const ENV_DEV = 'dev'
export const ENV_QA1 = 'qa1'
export const ENV_UAT = 'uat'
export const ENV_PROD = 'prod'

const VALID_ENVS = new Set([ENV_LOCAL, ENV_DEV, ENV_QA1, ENV_UAT, ENV_PROD])

export const deriveEnv = () => {
  if (typeof window === 'undefined') return ENV_LOCAL

  // Preferred: server-injected value in index.html.
  const injected = window.__ENV__ && window.__ENV__.NODE_ENV
  if (injected && VALID_ENVS.has(injected)) return injected

  // Fallback: only expected on the CRA dev server (webpack-dev-server serves
  // index.html directly, so our Express catch-all never runs to inject).
  // If we hit this branch on a deployed env, injection is broken — fall back
  // to LOCAL (silo5 assets) so the misconfiguration is loudly visible in the
  // browser rather than silently loading prod assets on a lower env.
  const host = window.location && window.location.hostname
  if (host !== 'localhost' && host !== '127.0.0.1') {
    console.warn('[runtimeEnv] window.__ENV__ missing; falling back to LOCAL. Backend injection may be broken.')
  }
  return ENV_LOCAL
}

const ADOBE_LAUNCH_STAGING =
  'https://assets.adobedtm.com/a162b9a7e516/fa8985725664/launch-ENe708f6d754c24f4abb6cf4f119787215-staging.min.js'
const ADOBE_LAUNCH_PROD =
  'https://assets.adobedtm.com/a162b9a7e516/fa8985725664/launch-EN54f2ba75a0d2456c9b6a76794f4d72be.min.js'

const WORKBENCH_SILO5_HEADER = 'https://header-silo5.awslecsanp.manheim.com/js/v1/ewbHeader_silo5.js'
const WORKBENCH_SILO5_FOOTER = 'https://header-silo5.awslecsanp.manheim.com/js/v1/ewbFooter_silo5.js'
const WORKBENCH_UAT_HEADER = 'https://header-uat.awslecsa.manheim.com/js/v1/ewbHeader_uat.js'
const WORKBENCH_UAT_FOOTER = 'https://header-uat.awslecsa.manheim.com/js/v1/ewbFooter_uat.js'
const WORKBENCH_PROD_HEADER = 'https://header.workbench.manheim.com/js/v1/ewbHeader_production.js'
const WORKBENCH_PROD_FOOTER = 'https://header.workbench.manheim.com/js/v1/ewbFooter.js'

const URLS = {
  [ENV_LOCAL]: {
    urlTracking: ADOBE_LAUNCH_STAGING,
    urlWorkbenchHeader: WORKBENCH_SILO5_HEADER,
    urlWorkbenchFooter: WORKBENCH_SILO5_FOOTER,
  },
  [ENV_DEV]: {
    urlTracking: ADOBE_LAUNCH_STAGING,
    urlWorkbenchHeader: WORKBENCH_SILO5_HEADER,
    urlWorkbenchFooter: WORKBENCH_SILO5_FOOTER,
  },
  [ENV_QA1]: {
    urlTracking: ADOBE_LAUNCH_STAGING,
    urlWorkbenchHeader: WORKBENCH_SILO5_HEADER,
    urlWorkbenchFooter: WORKBENCH_SILO5_FOOTER,
  },
  [ENV_UAT]: {
    urlTracking: ADOBE_LAUNCH_STAGING,
    urlWorkbenchHeader: WORKBENCH_UAT_HEADER,
    urlWorkbenchFooter: WORKBENCH_UAT_FOOTER,
  },
  [ENV_PROD]: {
    urlTracking: ADOBE_LAUNCH_PROD,
    urlWorkbenchHeader: WORKBENCH_PROD_HEADER,
    urlWorkbenchFooter: WORKBENCH_PROD_FOOTER,
  },
}

const env = deriveEnv()

export const runtimeEnv = {
  envName: env,
  ...URLS[env],
}
